/* src/app/drop-shipment/email-shipping-label/email-shipping-label.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.email-shipping-label-dialog {
  position: relative;
}
.email-shipping-label-dialog .ship-from-contact .ship-from-contact-items {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .email-shipping-label-dialog .ship-from-contact .ship-from-contact-items {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.email-shipping-label-dialog .ship-from-contact .ship-from-contact-items .mat-mdc-form-field {
  flex: 1;
}
@media screen and (min-width: 48rem) {
  .email-shipping-label-dialog .ship-from-contact .ship-from-contact-items .mat-mdc-form-field:first-of-type {
    padding-right: 1em;
  }
  .email-shipping-label-dialog .ship-from-contact .ship-from-contact-items .mat-mdc-form-field:last-of-type {
    padding-left: 1em;
  }
}
.email-shipping-label-dialog .emailTo {
  height: 17px;
  padding: 0;
}
.email-shipping-label-dialog .shipping-instruction-toggle {
  color: #004791;
  cursor: pointer;
}
.email-shipping-label-dialog .shipping-instructions {
  max-height: 0;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease;
}
.email-shipping-label-dialog .shipping-instructions.opened {
  max-height: 650px;
  visibility: visible;
  opacity: 1;
}
.email-shipping-label-dialog .upload-attachment {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.email-shipping-label-dialog .upload-attachment upsc-file-selector {
  width: 215px;
}
.email-shipping-label-dialog .upload-attachment .file-name {
  color: #00857d;
  padding: 0 2em;
  font-size: 1em;
}
.email-shipping-label-dialog .upload-attachment .remove-file {
  text-transform: uppercase;
}
.email-shipping-label-dialog .upload-attachment .remove-file a {
  color: #DF2901;
}
.file-upload input {
  position: absolute;
  opacity: 0;
  filter: alpha(opacity=0);
  -o-transform: translate(250px, -50px) scale(1);
  -moz-transform: translate(-300px, 0) scale(4);
  direction: ltr;
  cursor: pointer;
}
.upload-button {
  position: relative;
}
/*# sourceMappingURL=email-shipping-label.component.css.map */
